<template>
  <div class="ht-container ht-container-admin pb-5">
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
class ManageMembers extends Vue {

}
export default ManageMembers;
</script>

<style scoped>

</style>
